import * as React from "react";
import CustomerContextProvider from "../../customer/CustomerContextProvider/CustomerContextProvider";
import CartContextProvider, {isCart, useUnsafeCartContext} from "../CartContextProvider/CartContextProvider";
import AddToCartButtonPortal from "../AddToCartButton/AddToCartButtonPortal";
import CartIconPortal from "../CartIcon/CartIconPortal";
import AddToCartModal from "../../lib/ModalWindow/AddToCartModal";
import VoucherAddedModal from "../../lib/ModalWindow/VoucherAddedModal";

export const Cart: React.FC = () => {
  return (
    <React.Suspense fallback={null}>
      <CustomerContextProvider>
        <CartContextProvider>
          <CartIconPortal
            root={document.querySelector(".temp-cart-icon")}
            targetNode={document.querySelector("#CartIcon")}
          />
          <AddToCartButtonPortal
            targetNode={document.querySelector(".product-cart__form")}
            root={document.getElementById("AddToCartButtonRoot")}
          />
          <Modal />
          <VoucherAddedModal />
        </CartContextProvider>
      </CustomerContextProvider>
    </React.Suspense>
  );
};

const Modal: React.FC = () => {
  const context = useUnsafeCartContext();
  if (!context) {
    return null;
  }

  if (context.itemsAdded.length) {
    return (
      <AddToCartModal
        closeFunction={() => {
          context.setItemsAdded([]);
        }}
        toCartFunction={() => {
          if (!isCart(context)) {
            return;
          }
          context.setItemsAdded([]);
          context.setIsCartVisible(true);
        }}
        isVisible={true}
        itemIds={context.itemsAdded}
      />
    );
  }

  return null;
};
